import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-action-field',
  templateUrl: './action-field.component.html',
  styleUrls: ['./action-field.component.scss']
})
export class ActionFieldComponent implements OnInit {


  @Input() isDeletable: boolean;
  @Input() isRepeatable: boolean;
  @Output() addSomething = new EventEmitter();
  @Output() deleteSomething = new EventEmitter();

  constructor() {
  }


  @Input()
  ngOnInit(): void {
  }

  delete(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.deleteSomething.emit();
  }

  add(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.addSomething.emit();
  }
}
